import { Collapsible } from '@base-ui/react/collapsible'
import type { ReactNode } from 'react'
import { cx } from '../cx'
import { Icon } from '../Icon/Icon'
import styles from './Disclosure.module.css'

export function DisclosureChevron({
  open,
  className,
}: {
  open?: boolean
  className?: string
}) {
  return (
    <span
      className={cx(styles.chevron, className)}
      data-open={open ? '' : undefined}
      aria-hidden="true"
    >
      <Icon name="chevron-right" size="icon-embedded" />
    </span>
  )
}

export function Disclosure({
  label,
  count,
  defaultOpen,
  open,
  onOpenChange,
  ground = 'page',
  className,
  children,
}: {
  label: ReactNode
  count?: ReactNode
  /** `surface` (a card, an overlay) hovers and presses to raise (D190). */
  ground?: 'page' | 'surface'
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
  children: ReactNode
}) {
  return (
    <Collapsible.Root
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange ? (next) => onOpenChange(next) : undefined}
      className={cx(styles.disclosure, className)}
    >
      <Collapsible.Trigger className={styles.trigger} data-ground={ground}>
        <DisclosureChevron />
        <span className={styles.label}>{label}</span>
        {count != null && (
          <>
            {/* Whitespace-only text is not rendered in the flex row, but it
                keeps the accessible name "archived 1", not "archived1". */}{' '}
            <span className={styles.count}>{count}</span>
          </>
        )}
      </Collapsible.Trigger>
      <Collapsible.Panel className={styles.panel}>{children}</Collapsible.Panel>
    </Collapsible.Root>
  )
}
